import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-ocean-service-content',
    templateUrl: './ocean-service-content.component.html',
    styleUrls: ['./ocean-service-content.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OceanServiceContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
